import React from "react";

const selectTriggerBoxStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "fit-content",
  padding: "4px 8px",
  borderRadius: 4,
  marginTop: 8,
  fontSize: 12,
  lineHeight: "18px",
  fontWeight: 600,
};

export default ({ isSelected, node }) => {
  const triggerType = node.node_data.trigger_type;

  return (
    <div style={{
      ...selectTriggerBoxStyle,
      border: isSelected ? "1px solid var(--sl-border-brand)" : "1px solid var(--sl-border-primary)",
      color: isSelected ? "var(--sl-text-brand)" : "var(--sl-text-secondary)",
    }}>
      {triggerType ? node.node_data.event_type : "Select Trigger"}
    </div>
  );
};
